<div id="semi-circle-pie-chartdiv" style="width: 100%; height: 500px"></div>